"use client";

import { useState, useEffect } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  TransitionChild,
} from "@headlessui/react";
import {
  Bars3Icon,
  BellIcon,
  ChartPieIcon,
  Cog6ToothIcon,
  DocumentDuplicateIcon,
  XMarkIcon,
  PhoneIcon,
  ChartBarIcon,
  ClipboardIcon,
  UserCircleIcon,
  CurrencyDollarIcon,
} from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";

import Report from "../components/adminComponents/Report";
import LiveCall from "../components/adminComponents/LiveCall";
import Number from "../components/adminComponents/Number";
import ManageCampaign from "../components/adminComponents/ManageCampaign";
import ManageTarget from "../components/adminComponents/ManageTarget";
import Buyer from "../components/adminComponents/Buyer";
import logo from "../images/did_logo1.png";
import { Link } from "react-router-dom";
import Profile from "../components/ProfileDetail/Profile";
import PaymentHistory from "../components/adminComponents/Billing/PaymentHistory";

import RateCard from "../components/adminComponents/Billing/RateCard";
import InvoiceHistory from "../components/adminComponents/Billing/InvoiceHistory";
import ProfilePage from "../components/ProfileDetail/ProfilePage";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Example() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [teams, setTeams] = useState([
    // {
    //   id: 2,
    //   name: "Rate Card",
    //   component: <RateCard />,
    //   initial: "R",
    //   current: false,
    // },
   
    {
      id: 1,
      name: "Payment History",
      component: <PaymentHistory />,
      initial: "P",
      current: false,
    },
    {
      id: 2,
      name: "Invoice History",
      component: <InvoiceHistory />,
      initial: "I",
      current: false,
    },
  ]);
  const [navigation, setNavigation] = useState([
    {
      name: "Report",
      component: <Report />,
      icon: ChartBarIcon,
      current: true,
    },
    {
      name: "Live Calls",
      component: <LiveCall />,
      icon: PhoneIcon,
      current: false,
    },
    { name: "Number", component: <Number />, icon: PhoneIcon, current: false },
    {
      name: "Manage Campaign",
      component: <ManageCampaign />,
      icon: DocumentDuplicateIcon,
      current: false,
    },
    {
      name: "Manage Target",
      component: <ManageTarget />,
      icon: ClipboardIcon,
      current: false,
    },
    { name: "Buyer", component: <Buyer/>, icon: ChartPieIcon, current: false },
  ]);
  const [currentComponent, setCurrentComponent] = useState(navigation[0].component);
const [currentDateTime, setCurrentDateTime] = useState(
  new Date()
    .toLocaleString("en-GB", {
      timeZone: "GMT",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    })
    .replace(/(\d+)\/(\d+)\/(\d+), (\d+:\d+:\d+)/, "$3-$2-$1 $4 UTC")
);

const navigate = useNavigate();

const handleAuthError = () => {
  localStorage.removeItem('token');
  navigate('/login');
};

useEffect(() => {
  const timer = setInterval(() => {
    setCurrentDateTime(
      new Date()
        .toLocaleString("en-GB", {
          timeZone: "GMT",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        })
        .replace(/(\d+)\/(\d+)\/(\d+), (\d+:\d+:\d+)/, "$3-$2-$1 $4 UTC")
    );
  }, 1000);

  return () => clearInterval(timer);
}, []);

const [walletBalance, setWalletBalance] = useState(0);

const fetchWalletBalance = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      handleAuthError();
      return;
    }

    // First try to get the user profile to get user details
    const profileResponse = await fetch("https://didrouteapi.com/api/users/profile", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!profileResponse.ok) {
      if (profileResponse.status === 401 || profileResponse.status === 403) {
        handleAuthError();
        return;
      }
      return;
    }

    const profileData = await profileResponse.json();

    // Try to get wallet by user ID directly
    const walletResponse = await fetch(`https://didrouteapi.com/api/wallet/user/${profileData.id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (walletResponse.ok) {
      const data = await walletResponse.json();
      setWalletBalance(data.current_balance || 0);
    } else if (walletResponse.status === 404) {
      const checkWalletResponse = await fetch(`https://didrouteapi.com/api/wallet/check/${profileData.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const checkResult = await checkWalletResponse.json();
      
      if (!checkResult.exists) {
        const createWalletResponse = await fetch("https://didrouteapi.com/api/wallet", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            user_id: profileData.id,
            user_name: profileData.name,
            campaign_id: 0,
            buyer_id: 0,
            number_id: 0,
            current_balance: 0
          })
        });

        if (createWalletResponse.ok) {
          const newWalletData = await createWalletResponse.json();
          setWalletBalance(newWalletData.current_balance || 0);
        } else {
          const errorData = await createWalletResponse.json();
          if (errorData.message === 'Wallet already exists for this user') {
            const existingWalletResponse = await fetch(`https://didrouteapi.com/api/wallet/user/${profileData.id}`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
            
            if (existingWalletResponse.ok) {
              const data = await existingWalletResponse.json();
              setWalletBalance(data.current_balance || 0);
            }
          }
        }
      } else {
        setWalletBalance(checkResult.wallet.current_balance || 0);
      }
    }
  } catch (error) {
    console.error('Error fetching wallet balance:', error);
    if (error.message.includes('token')) {
      handleAuthError();
    }
  }
};

useEffect(() => {
  fetchWalletBalance();
}, []);

useEffect(() => {
  const balanceInterval = setInterval(() => {
    fetchWalletBalance();
  }, 3000);

  return () => clearInterval(balanceInterval);
}, []);

  return (
    <>
      {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-white">
        <body class="h-full">
        ```
      */}
      <div className="mt-[-64px]">
        <Dialog
          open={sidebarOpen}
          onClose={setSidebarOpen}
          className="relative z-50 lg:hidden"
        >
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
          />

          <div className="fixed inset-0 flex">
            <DialogPanel
              transition
              className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-[closed]:-translate-x-full"
            >
              <TransitionChild>
                <div className="absolute left-full top-0 flex w-16 justify-center pt-5 duration-300 ease-in-out data-[closed]:opacity-0">
                  <button
                    type="button"
                    onClick={() => setSidebarOpen(false)}
                    className="-m-2.5 p-2.5"
                  >
                    <span className="sr-only">Close sidebar</span>
                    <XMarkIcon
                      aria-hidden="true"
                      className="size-6 text-white"
                    />
                  </button>
                </div>
              </TransitionChild>
              {/* Sidebar component, swap this element with another sidebar if you like */}
              <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-gray-900 px-6 pb-4 ring-1 ring-white/10">
                <div className="flex h-16 shrink-0 items-center">
                  <Link to="/">
                    <img alt="Your Company" src={logo} className="h-8 w-auto" />
                  </Link>
                </div>
                <nav className="flex flex-1 flex-col">
                  <ul role="list" className="flex flex-1 flex-col gap-y-7">
                    <li>
                      <ul role="list" className="-mx-2 space-y-1">
                        {navigation.map((item) => (
                          <li key={item.name}>
                            <a
                              href={item.href}
                              onClick={() => {
                                setCurrentComponent(item.component);
                                setNavigation(navigation.map(nav => ({
                                  ...nav,
                                  current: nav.name === item.name
                                })));
                                setTeams(teams.map(t => ({
                                  ...t,
                                  current: false
                                })));
                              }}
                              className={classNames(
                                item.current
                                  ? "bg-gray-800 text-gray-300"
                                  : "text-gray-300 hover:bg-gray-800 hover:text-white",
                                "group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold"
                              )}
                            >
                              <item.icon
                                aria-hidden="true"
                                className="size-6 shrink-0"
                              />
                              {item.name}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </li>
                    {/* <li>
                      <div className="text-xs/6 font-semibold text-gray-400">
                        Your teams
                      </div>
                      <ul role="list" className="-mx-2 mt-2 space-y-1">
                        {teams.map((team) => (
                          <li key={team.name}>
                            <a
                              href={team.href}
                              className={classNames(
                                team.current
                                  ? "bg-gray-800 text-white"
                                  : "text-gray-400 hover:bg-gray-800 hover:text-white",
                                "group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold"
                              )}
                            >
                              <span className="flex size-6 shrink-0 items-center justify-center rounded-lg border border-gray-700 bg-gray-800 text-[0.625rem] font-medium text-gray-400 group-hover:text-white">
                                {team.initial}
                              </span>
                              <span className="truncate">{team.name}</span>
                            </a>
                          </li>
                        ))}
                      </ul>
                    </li> */}
                    <li className="mt-auto">
                      <a
                        href="#"
                        className="group -mx-2 flex gap-x-3 rounded-md p-2 text-gray-400 hover:bg-gray-800 hover:text-white"
                      >
                        <Cog6ToothIcon
                          aria-hidden="true"
                          className="size-6 shrink-0"
                        />
                        Help Center
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </DialogPanel>
          </div>
        </Dialog>

        {/* Static sidebar for desktop */}
        <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-48 lg:flex-col border-r border-gray-200">
          {/* Sidebar component, swap this element with another sidebar if you like */}
          <div className="flex grow flex-col gap-y-5 overflow-y-auto custom-scrollbar  bg-white px-4 pb-4">
            <Link to="/" className="flex h-16 shrink-0 items-center">
              <img alt="Your Company" src={logo} className="h-12 w-80" />
            </Link>


            <nav className="flex flex-1 flex-col">
              <ul role="list" className="flex flex-1 flex-col gap-y-7">
                <li>
                  <ul role="list" className="-mx-2">
                    <div className="text-gray-900 flex items-center font-semibold mb-2 px-2 pb-2 rounded-md shadow-sm">
                      <span className="text-xs">
                        {currentDateTime}
                      </span>
                    </div>

                    {navigation.map((item) => (
                      <li key={item.name}>
                        <a
                          href={item.href}
                          onClick={() => {
                            setCurrentComponent(item.component);
                            setNavigation(navigation.map(nav => ({
                              ...nav,
                              current: nav.name === item.name
                            })));
                            setTeams(teams.map(t => ({
                              ...t,
                              current: false
                            })));
                          }}
                          className={classNames(
                            item.current
                              ? "bg-gray-200 text-black"
                              : "text-gray-900  ",
                            "group flex gap-x-3 rounded-md p-2 text-xs/5 font-medium"
                          )}
                        >
                          <item.icon
                            aria-hidden="true"
                            className="size-4 shrink-0"
                          />
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </li>
                <li>
                  <div className="text-xs/6 font-semibold text-gray-800">
                    Biiling
                  </div>
                  <ul role="list" className="-mx-2 mt-2 space-y-1">
                    {teams.map((team) => (
                      <li key={team.name}>
                        <a
                          href={team.href}
                          onClick={() => {
                            setCurrentComponent(team.component);
                            setTeams(teams.map(t => ({
                              ...t,
                              current: t.id === team.id
                            })));
                            setNavigation(navigation.map(nav => ({
                              ...nav,
                              current: false
                            })));
                          }}
                          className={classNames(
                            team.current
                              ? "bg-gray-200 text-black"
                              : "text-gray-900 ",
                            "group flex gap-x-3 rounded-md p-2 text-xs/5 font-medium"
                          )}
                        >
                          <span className="flex size-5 shrink-0 items-center justify-center rounded-lg border border-gray-700 bg-white text-[0.625rem] font-medium text-black group-hover:text-gray-800">
                            {team.initial}
                          </span>
                          <span className="truncate">{team.name}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </li>
                <li className="mt-auto">
                  <a
                    href="#"
                    className="group -mx-2 flex gap-x-3 rounded-md p-2 text-xs/5 font-semibold text-black hover:bg-gray-300 hover:text-black"
                  >
                    <Cog6ToothIcon
                      aria-hidden="true"
                      className="size-5 shrink-0"
                    />
                    Help Center
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <div className="lg:pl-48">
          <div className="sticky top-0 z-40 flex h-14 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6">
            <button
              type="button"
              onClick={() => setSidebarOpen(true)}
              className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
            >
              <span className="sr-only">Open sidebar</span>
              <Bars3Icon aria-hidden="true" className="size-6" />
            </button>

            {/* Separator */}
            <div
              aria-hidden="true"
              className="h-6 w-px bg-gray-900/10 lg:hidden"
            />

            <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
              {/* <div className="text-gray-800 flex items-center font-semibold bg-gray-200 my-2.5 px-2 py-1 rounded-md shadow-sm">
                <span className="text-sm">{currentDateTime} (GMT)</span>
              </div> */}

              <form action="#" method="GET" className="grid flex-1 grid-cols-1">
                {/* <input
                  name="search"
                  type="search"
                  placeholder=""
                  aria-label="Search"
                  className="col-start-1 row-start-1 block size-full bg-white pl-8 text-base text-gray-900 outline-none placeholder:text-gray-400 sm:text-sm/6"
                /> */}
                {/* <MagnifyingGlassIcon
                  aria-hidden="true"
                  className="pointer-events-none col-start-1 row-start-1 size-5 self-center text-gray-400"
                /> */}
              </form>
              <div className="flex items-center gap-x-3 lg:gap-x-3">
                <div className="flex items-center gap-1">
                  <CurrencyDollarIcon className="h-5 w-5 text-gray-600" />
                  {/* <span className="text-sm font-medium text-gray-700">Balance:</span> */}
                  <span className="text-sm font-semibold text-green-600">
                    ${walletBalance.toFixed(2)}
                  </span>
                </div>
                <button
                  type="button"
                  className="-m-2.5 p-2.5 text-gray-700 hover:text-gray-900"
                >
                  <span className="sr-only">View notifications</span>
                  <BellIcon aria-hidden="true" className="size-5" />
                </button>

                {/* Separator */}
                <div
                  aria-hidden="true"
                  className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-900/10"
                />

                {/* Profile dropdown */}
                <Profile setCurrentComponent={setCurrentComponent} />
              </div>
            </div>
          </div>

          <main className="py-6 mt-[64px]">
            <div className="px-2 sm:px-2 lg:px-4">{currentComponent}</div>
          </main>
        </div>
      </div>
    </>
  );
}
